module.exports = __webpack_public_path__ + "img/NMC-alt.b514b90c.svg";